export const SubjectCodes = [
  'ENGK006',
  'ENGK013',
  'NAT1Z22',
  'NAT1Z17',
  'MHE2Z12',
  'MAT1Z29',
];
